export enum ProcessorPropertyCommonTypes {
  String = 'string',
  Number = 'number',
  Boolean = 'boolean',
}

export enum ProcessorPropertyExcelTypes {
  Hyperlink = 'excel-hyperlink',
  Percentage = 'excel-percentage',
  Image = 'excel-image',
  Date = 'excel-date',
  DateTime = 'excel-datetime',
}

export enum ProcessorPropertyAVETypes {
  StatusERP = 'ave-status-erp',
}
